var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 29 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3594_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.06 21.68H3.11C1.4 21.68 0 20.29 0 18.57V14.47H0.72C2.73 14.47 4.36 12.84 4.36 10.83C4.36 8.82 2.73 7.19 0.72 7.19H0V3.11C0 1.39 1.39 0 3.11 0H25.07C26.78 0 28.18 1.39 28.18 3.11V7.21H27.46C25.46 7.21 23.83 8.85 23.83 10.85C23.83 12.85 25.46 14.49 27.46 14.49H28.18V18.59C28.18 20.3 26.79 21.7 25.07 21.7L25.06 21.68ZM1.44 15.87V18.58C1.44 19.5 2.19 20.25 3.11 20.25H25.07C25.99 20.25 26.74 19.5 26.74 18.58V15.87C24.28 15.52 22.39 13.4 22.39 10.85C22.39 8.3 24.29 6.18 26.74 5.83V3.12C26.74 2.2 25.99 1.45 25.07 1.45H3.11C2.19 1.45 1.44 2.2 1.44 3.12V5.83C3.9 6.18 5.8 8.3 5.8 10.86C5.8 13.42 3.9 15.54 1.44 15.89V15.87Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1502 4.57C13.7502 4.57 13.4302 4.25 13.4302 3.85V0.72C13.4302 0.32 13.7502 0 14.1502 0C14.5502 0 14.8702 0.32 14.8702 0.72V3.85C14.8702 4.25 14.5502 4.57 14.1502 4.57Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1502 21.6799C13.7502 21.6799 13.4302 21.3599 13.4302 20.9599V17.8299C13.4302 17.4299 13.7502 17.1099 14.1502 17.1099C14.5502 17.1099 14.8702 17.4299 14.8702 17.8299V20.9599C14.8702 21.3599 14.5502 21.6799 14.1502 21.6799Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1502 14.3099C13.7502 14.3099 13.4302 13.9899 13.4302 13.5899V8.07986C13.4302 7.67986 13.7502 7.35986 14.1502 7.35986C14.5502 7.35986 14.8702 7.67986 14.8702 8.07986V13.5899C14.8702 13.9899 14.5502 14.3099 14.1502 14.3099Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3594_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.17,
    height: 21.68,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.1553fde0510ae4c1eac92e398dd4377a.svg";
export { ForwardRef as ReactComponent };